var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCollapse = function SvgCollapse(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_872_194948)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.732422 4.00007C0.732422 2.19594 2.19496 0.733398 3.99909 0.733398H11.9991C13.8032 0.733398 15.2658 2.19594 15.2658 4.00007V12.0001C15.2658 13.8042 13.8032 15.2667 11.9991 15.2667H3.99909C2.19496 15.2667 0.732422 13.8042 0.732422 12.0001V4.00007ZM3.99909 1.9334C2.8577 1.9334 1.93242 2.85868 1.93242 4.00007V12.0001C1.93242 13.1415 2.8577 14.0667 3.99909 14.0667H11.9991C13.1405 14.0667 14.0658 13.1415 14.0658 12.0001V4.00007C14.0658 2.85868 13.1405 1.9334 11.9991 1.9334H3.99909ZM4.73242 8.00007C4.73242 7.66869 5.00105 7.40006 5.33242 7.40006H10.6658C10.9971 7.40006 11.2658 7.66869 11.2658 8.00007C11.2658 8.33144 10.9971 8.60007 10.6658 8.60007H5.33242C5.00105 8.60007 4.73242 8.33144 4.73242 8.00007Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_872_194948"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCollapse);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "collapse.207ba1c8fb8f0698a74ea76575fb46a3.svg";